import React, { useRef } from 'react';


import World from '../../../images/pages/cases/ai-driven/world.png';
import Pin2 from '../../../images/pages/cases/ai-driven/pin-2.png';
import Check from '../../../images/pages/cases/ai-driven/check.png';
import { AnimateBlock1, AnimateBlock2 } from './AiDrivenSolution2Svg';

const AiDrivenSolution2 = () => {
    const blockRef = useRef(null);
    const worldRef = useRef(null);
    const pin2Ref = useRef(null);
    const check1Ref = useRef(null);

    return (
        <div className="animation-block" ref={blockRef}>
            <div className="animation-block__img" >
                <img src={World} className="world" alt="world" ref={worldRef} width="400" height="400" />
                <img src={Pin2} className="pin" alt="happy man" ref={pin2Ref} width="105" height="145" />
            </div>
            <div className="animation-block__anim">
                <AnimateBlock1/>
                <img src={Check} className="check check--1" alt="decor" ref={check1Ref} width="45" height="36" />

                <AnimateBlock2/>
                <img src={Check} className="check check--2" alt="decor" ref={check1Ref} width="45" height="36" />
            </div>
        </div>
    );
};

export default AiDrivenSolution2;

